import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILogin, ISetPassword, ISignup } from '../interfaces/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private httpClient: HttpClient) {}

  login(url: string, loginForm: any): Observable<ILogin> {
    return this.httpClient.post<ILogin>(url, loginForm, {
      headers: { accept: '*/*' },
    }) as Observable<ILogin>;
  }

  signup(url: string, signupForm: any): Observable<ISignup> {
    return this.httpClient.post<ISignup>(url, signupForm, {
      headers: { accept: '*/*' },
    }) as Observable<ISignup>;
  }

  setPassword(url: string, setPasswordForm: any): Observable<ISetPassword> {
    return this.httpClient.patch<ISetPassword>(url, setPasswordForm, {
      headers: { accept: '*/*' },
    }) as Observable<ISetPassword>;
  }

  resetPassword(url: string, resetPasswordForm: any): Observable<ISetPassword> {
    return this.httpClient.patch<ISetPassword>(url, resetPasswordForm, {
      headers: { accept: '*/*' },
    }) as Observable<ISetPassword>;
  }
}
